import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts"

const OfficeWiseChart = ({ data }) => (
  <ResponsiveContainer width="100%" height="100%">
    <BarChart 
        data={data}
        margin={{ top: 10, right: 10, left: -10 }}
    >
      <XAxis dataKey="officeName" tick={{ fontSize: 8 }} angle={-30} textAnchor="end" />
      <YAxis />
      <Tooltip />
      <Bar dataKey="totalGrievances" fill="#004877"  barSize={20} />
    </BarChart>
  </ResponsiveContainer>
)

export default OfficeWiseChart
